import { render } from "./StatusIcon.vue?vue&type=template&id=e62b1e30"
const script = {}

import "./StatusIcon.vue?vue&type=style&index=0&id=e62b1e30&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/luch-order-web-request_main-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__